import Loadable from '../../components/loadable';

const StartMembershipImportModal = Loadable({
  loader: () => import('../../pages/reports/start_membership_import_modal'),
  type: 'drawer',
});

angular.module('gym').value('StartMembershipImportModal', StartMembershipImportModal);
